<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="1.5 1.5 21 21"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="5" width="18" height="16" rx="3" />
    <path d="M8 3v4M16 3v4M3 9h18" />
    <rect
      x="7"
      y="12"
      width="4"
      height="4"
      rx="1.2"
      fill="currentColor"
      stroke="none"
    />
    <path d="M14 14h3M14 17h3" />
  </svg>
</template>

<script setup>
// import { computed, inject, onMounted } from "vue";
</script>

<style scoped>
</style>
